import React from 'react';
import styled from 'styled-components';

const StyledInput = styled.input`
  height: 42px;
  width: 100%;
  font-size: 16px;
  background-color: ${props => props.theme.colors.veryLightBlue};
  border: ${props => props.error === true ? `.5px solid ${props.theme.colors.red}` : 
  `.5px solid ${props.theme.colors.lightGray}`};
  
  border-radius: 2px;
  padding: 15px;
  color: ${props => props.theme.colors.text.gray};

  &:focus {
    border: .5px solid ${props => props.theme.colors.mediumBlue};
  }

  &:invalid {
    border: .5px solid ${props => props.theme.colors.red};
  }
`;

const StyledTextArea = styled.textarea`
  height: 50px;
  width: 100%;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  background-color: ${props => props.theme.colors.veryLightBlue};
  border: .5px solid ${props => props.theme.colors.lightGray};
  border-radius: 2px;
  padding: 20px;
  color: ${props => props.theme.colors.text.gray};
  height: 200px;
`;

function Input(props) {
  return (
    props.multiline ? 
    <StyledTextArea {...props} /> :
    <StyledInput {...props} />
  );
}

export default Input;
